import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@totalsoft/rocket-ui';

const Header = ({ productName, title }) => {
  const [t] = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {productName ? `${t('FinancialProduct.Title')} - ${productName} - ` : ''}{title ? `${t('FinancialProduct.Details.Rules.TitleRule')} ${title}` : t('FinancialProduct.Details.Rules.TitleRule')}
    </Typography>
  );
};

Header.propTypes = {
  productName: PropTypes.string,
  title: PropTypes.string
};

export default Header;
